import React, { useState } from "react";

import { useNavigate } from "react-router-dom";
import classNames from "classnames/bind";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTableList, faChartLine } from "@fortawesome/free-solid-svg-icons";

import putPlantingData from "../Api/putPlantingData";

import styles from "../scss/footer-mobile.module.scss";

const cx = classNames.bind(styles);

export default function MobileFooter(props) {
  const navigate = useNavigate();
  const [isRotate, setIsRotate] = useState(false);

  const save = async function save(recordPlantingData) {
    // console.log('recordPlantingData:', recordPlantingData)
    await putPlantingData(recordPlantingData);
  };

  return (
    <div className={cx("main")}>
      <div className={cx("menu")}>
        <FontAwesomeIcon
          icon={faChartLine}
          className={cx("menu__base")}
          src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjxzdmcgaGVpZ2h0PSIxMnB4IiB2ZXJzaW9uPSIxLjEiIHZp%0D%0AZXdCb3g9IjAgMCAxOCAxMiIgd2lkdGg9IjE4cHgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8y%0D%0AMDAwL3N2ZyIgeG1sbnM6c2tldGNoPSJodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0%0D%0AY2gvbnMiIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj48dGl0bGUv%0D%0APjxkZXNjLz48ZGVmcy8+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBpZD0iUGFn%0D%0AZS0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSI+PGcgZmlsbD0iIzAwMDAwMCIgaWQ9%0D%0AIkNvcmUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC04Ny4wMDAwMDAsIC0zNDIuMDAwMDAwKSI+PGcg%0D%0AaWQ9Im1lbnUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDg3LjAwMDAwMCwgMzQyLjAwMDAwMCkiPjxw%0D%0AYXRoIGQ9Ik0wLDEyIEwxOCwxMiBMMTgsMTAgTDAsMTAgTDAsMTIgTDAsMTIgWiBNMCw3IEwxOCw3%0D%0AIEwxOCw1IEwwLDUgTDAsNyBMMCw3IFogTTAsMCBMMCwyIEwxOCwyIEwxOCwwIEwwLDAgTDAsMCBa%0D%0AIiBpZD0iU2hhcGUiLz48L2c+PC9nPjwvZz48L3N2Zz4="
        />
        <FontAwesomeIcon
          icon={faTableList}
          onClick={(e) => {
            props.handleIsStartRecord(e, false);
            navigate("/apps/record");
          }}
          className={cx("menu__base")}
        />
        <div
          onClick={(e) => {
            save(props.saveRecordPlantingData);
            setIsRotate(!isRotate);
          }}
          className={cx("menu__trigger", {
            rotate: isRotate,
          })}
          id="btn"
        >
          save
        </div>
      </div>
    </div>
  );
}
